import EventDetails from "@/components/event/EventDetails.vue";
import { isAdminNotConsultant } from "@/js/http/auth.js";
export default {
  name: "AdminEventDetails",
  props: ["loggedUserData"],
  components: {
    EventDetails: EventDetails
  },
  data: function data() {
    return {
      id: null
    };
  },
  created: function created() {
    this.id = +this.$route.params.id;
  },
  methods: {
    isAdminNotConsultant: isAdminNotConsultant
  }
};